import { render, staticRenderFns } from "./notifacation.vue?vue&type=template&id=6793081c&"
import script from "./notifacation.vue?vue&type=script&lang=js&"
export * from "./notifacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports